module.exports = __webpack_public_path__ + "static/media/notfound.df2774e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notfound.jpg
// module id = 2181
// module chunks = 0